/*
 * grid_list_toggler.js — esbuild IIFE entry
 * Migrated from app/assets/javascripts/grid_list_toggler.js
 * Used by shared/_grid_list_toggler partial on products and projects listing pages.
 */
import 'jquery.cookie';

window.GridListToggler = {
    initialize(listSelector) {
        $('a.grid-list-toggler').on('click', (e) => GridListToggler.buttonClickedHandler(e, listSelector));
        const value = GridListToggler.getViewMode();
        GridListToggler._setActiveButton(value);
        GridListToggler._setActiveListClass(listSelector, value);
    },

    buttonClickedHandler(event, listSelector) {
        const value = $(event.target).closest('a').data('mode');
        GridListToggler._setCookie(value);
        GridListToggler._setActiveButton(value);
        GridListToggler._setActiveListClass(listSelector, value);
    },

    moveToGrid() {
        $('a.grid-list-toggler').on('click', (event) => {
            const url = new URL(document.URL);
            url.searchParams.set('view', $(event.target).closest('a').data('mode'));
            window.location = url.href;
        });
    },

    getViewMode() {
        return GridListToggler._getViewType() || $.cookie('display-mode') || 'list';
    },

    _getViewType() {
        const url = new URL(document.URL);
        const viewType = url.searchParams.get('view');
        if (viewType) {
            history.replaceState('', '', url.pathname + url.search);
            GridListToggler._setCookie(viewType);
            return viewType;
        }
    },

    _setCookie(value) {
        const url = new URL(document.URL);
        url.searchParams.set('view', value);
        $.cookie('display-mode', value, { path: url.pathname });
        history.replaceState('', '', url.pathname + url.search);
    },

    _setActiveButton(value) {
        $('a.grid-list-toggler').removeClass('active');
        $(`a.grid-list-toggler[data-mode='${value}']`).addClass('active');
    },

    _setActiveListClass(listSelector, value) {
        if (value === 'list') {
            $(listSelector).removeClass('vertical');
        } else {
            $(listSelector).addClass('vertical');
        }
    }
};
